/**
 * Lightweight loading/skeleton states for the Content Menu.
 *
 * These are extracted into a separate file so that components that only need
 * the loading skeleton (e.g. LoadableLazy loading fallbacks in RecentItem and
 * StarredItem) don't pull in the heavier ContentMenuStates module which
 * includes SVG image imports for error/empty/no-results states.
 */
import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const skeletonProps = {
	height: '9px',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	isShimmering: true,
	color: token('color.skeleton'),
	ShimmeringEndColor: token('color.skeleton.subtle'),
};

export const ContentMenuLoadingState = (): React.JSX.Element => {
	return (
		<Box paddingBlock="space.300">
			<Stack
				space="space.300"
				alignBlock="center"
				alignInline="center"
				grow="fill"
				testId="content-menu-loading"
			>
				{[...Array(10)].map((_, index) => (
					<Skeleton key={index} width="250px" {...skeletonProps} />
				))}
			</Stack>
		</Box>
	);
};

export const ContentMenuLoadMoreState = (): React.JSX.Element => {
	return (
		<Box padding="space.300">
			<Stack space="space.300" grow="fill" testId="content-menu-load-more">
				<Skeleton width="180px" {...skeletonProps} />
				<Skeleton width="140px" {...skeletonProps} />
				<Skeleton width="180px" {...skeletonProps} />
				<Skeleton width="140px" {...skeletonProps} />
			</Stack>
		</Box>
	);
};
